import About from "./about/About";
import ContactSection from "./contact/Contact";
import Features from "./features/Features";
import Hero from "./hero/hero"
import 'aos/dist/aos.css';

import AOS from 'aos';
import { useEffect } from "react";
import Services from "./services/Services";

const Home = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Hero />
            <About />
            <Services />
            <Features />
            <ContactSection />
        </>

    )
}

export default Home;